var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
import { pageWindow } from '../../../domain';
/** Um par rotulo/valor do cabecalho, das metas e da anamnese. */
let InfoFieldScope = class InfoFieldScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.value = '-';
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], InfoFieldScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], InfoFieldScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], InfoFieldScope.prototype, "suffix", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], InfoFieldScope.prototype, "suffixColor", void 0);
InfoFieldScope = __decorate([
    Observable
], InfoFieldScope);
export { InfoFieldScope };
/**
 * Um bloco da anamnese: o titulo e os campos dele.
 *
 * Sao cinco na referencia, cada um com a sua grade - "ESTADO DE SAÚDE" tem tres
 * colunas, "DADOS DE ATIVIDADE FÍSICA" tem duas, e os outros tres nao tem grade
 * alguma: um campo solto embaixo do titulo.
 */
let AnamneseSectionScope = class AnamneseSectionScope extends Scope {
    constructor() {
        super(...arguments);
        this.title = '';
        /** As classes da grade, ou vazio quando o bloco tem um campo so. */
        this.grid = '';
        this.fields = [];
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], AnamneseSectionScope.prototype, "title", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], AnamneseSectionScope.prototype, "grid", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], AnamneseSectionScope.prototype, "fields", void 0);
AnamneseSectionScope = __decorate([
    Observable
], AnamneseSectionScope);
export { AnamneseSectionScope };
/**
 * Uma celula de uma das duas tabelas de historico - uma medicao, ou a origem.
 *
 * A origem virou celula em 05/10/2026, quando as colunas passaram a ser arrastaveis:
 * antes ela era um campo da LINHA, desenhado sempre na segunda posicao, e mover a
 * coluna dela deixaria o conteudo para tras.
 */
let HistoryCellScope = class HistoryCellScope extends Scope {
    constructor() {
        super(...arguments);
        /** O campo da coluna a que a celula pertence: o id do tipo, ou `origem`. */
        this.field = '';
        /** Verdadeiro na celula de "Dispositivo de Origem": `value` e o aparelho. */
        this.source = false;
        this.value = '-';
        /**
         * Verdadeiro quando a celula resume UMA leitura so.
         *
         * E a marca que o cliente pediu, com o unico criterio que nao tem numero a
         * escolher: nao diz que a medicao e anormal, diz que este numero nao e uma
         * media.
         */
        this.single = false;
        /** Abre o detalhamento: as leituras cruas que esta celula resumiu. */
        this.onSelect = Scope.ASYNC_ACTION;
        /** O valor CRU, para a ordenacao ser por numero e nao por texto. */
        this.sortValue = null;
    }
};
__decorate([
    observe(),
    __metadata("design:type", String)
], HistoryCellScope.prototype, "sourceIcon", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], HistoryCellScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], HistoryCellScope.prototype, "statusName", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], HistoryCellScope.prototype, "statusColor", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], HistoryCellScope.prototype, "range", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], HistoryCellScope.prototype, "single", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], HistoryCellScope.prototype, "sortValue", void 0);
HistoryCellScope = __decorate([
    Observable
], HistoryCellScope);
export { HistoryCellScope };
/** Um cabecalho de uma das duas tabelas de historico. */
let HistoryColumnScope = class HistoryColumnScope extends Scope {
    constructor() {
        super(...arguments);
        this.field = '';
        this.label = '';
        this.sorted = false;
        this.descending = false;
        /** Falso na primeira coluna, a data ou a hora, que fica presa a esquerda. */
        this.movable = false;
        this.onSort = Scope.ASYNC_ACTION;
        /** Soltaram sobre esta coluna a de campo `source`: ela passa a ocupar este lugar. */
        this.onDrop = Scope.ASYNC_ACTION_STRING;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], HistoryColumnScope.prototype, "field", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], HistoryColumnScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], HistoryColumnScope.prototype, "sorted", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], HistoryColumnScope.prototype, "descending", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], HistoryColumnScope.prototype, "movable", void 0);
HistoryColumnScope = __decorate([
    Observable
], HistoryColumnScope);
export { HistoryColumnScope };
/**
 * Uma linha de historico - serve as DUAS tabelas.
 *
 * Na lista de dias, `label` e a data e `onOpen` abre o dia; na lista de leituras de
 * um dia, `label` e a hora e nao ha o que abrir. As celulas sao as medicoes, na
 * ordem das colunas daquela tabela.
 */
let HistoryRowScope = class HistoryRowScope extends Scope {
    constructor() {
        super(...arguments);
        /** A data por extenso, ou a hora - conforme a tabela. */
        this.label = '-';
        /** `yyyy-MM-dd`, so nas linhas de dia: e a chave com que o dia vai para a URL. */
        this.day = '';
        /** Uma por coluna, depois da primeira, e na ordem delas. */
        this.cells = [];
        /** O instante em milissegundos, para ordenar por tempo. */
        this.sortValue = 0;
        this.onOpen = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], HistoryRowScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], HistoryRowScope.prototype, "day", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], HistoryRowScope.prototype, "cells", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], HistoryRowScope.prototype, "sortValue", void 0);
HistoryRowScope = __decorate([
    Observable
], HistoryRowScope);
export { HistoryRowScope };
let PatientDetailScope = class PatientDetailScope extends Scope {
    constructor() {
        super(...arguments);
        this.loading = true;
        /**
         * O rotulo do botao de voltar.
         *
         * Nao e fixo porque a tela esta montada em dois lugares: vindo de Colaboradores
         * ele diz "Dados do Colaborador", vindo dos Monitoramentos diz "Monitoramentos
         * Compartilhados" - o nome da lista para onde o clique leva.
         */
        this.backLabel = 'Dados do Colaborador';
        this.name = '-';
        this.email = '-';
        this.cpf = '-';
        this.active = true;
        this.identification = [];
        this.anamneseSections = [];
        this.targets = [];
        /**
         * O historico, numa tabela so.
         *
         * Quando ha dia aberto sao as LEITURAS daquele dia; quando nao, sao os DIAS. A
         * referencia troca a tela inteira nesse caso - nao expande uma linha -, e por
         * isso uma lista de linhas basta para os dois estados.
         */
        this.historyColumns = [];
        this.historyRows = [];
        this.historyPage = 1;
        this.historyPageCount = 1;
        /** O dia aberto, vindo do endereco - vazio quando a tela mostra a lista de dias. */
        this.openDay = '';
        /** Ligado enquanto as leituras do dia aberto nao chegaram. */
        this.loadingDay = false;
        /** A data do dia aberto, por extenso, para o cabecalho daquele modo. */
        this.openDayLabel = '';
        // :: o relatorio do dia aberto, em PDF (B-29)
        /** Ligado enquanto as leituras sao buscadas e o PDF montado. */
        this.downloadingDay = false;
        /**
         * Quanto da busca ja voltou - `34 de 120` -, vazio fora dela.
         *
         * O relatorio le cada celula do dia, e um dia cheio passa de cem: sem o numero, o
         * botao ficaria "Gerando…" por segundos sem dizer se anda.
         */
        this.dayReportProgress = '';
        this.onDownloadDay = Scope.ASYNC_ACTION;
        this.onCloseDay = Scope.ASYNC_ACTION;
        this.onPreviousPage = Scope.ASYNC_ACTION;
        this.onNextPage = Scope.ASYNC_ACTION;
        this.onGoToPage = Scope.ASYNC_ACTION_NUMBER;
        this.onBack = Scope.ASYNC_ACTION;
    }
    /**
     * As paginas que o paginador oferece - lista pronta, e nao uma regra a aplicar.
     *
     * Deriva de `historyPage` e `pageCount`, os dois ja observados, entao muda junto com
     * eles. Fica aqui e nao na view para que outra renderizacao so LEIA: quem desenha
     * nao precisa saber que a janela tem cinco nem que ela se centra na atual.
     */
    get historyPageWindow() {
        return pageWindow(this.historyPage, this.historyPageCount);
    }
};
__decorate([
    observe(),
    __metadata("design:type", Function)
], PatientDetailScope.prototype, "historyLayout", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientDetailScope.prototype, "loading", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], PatientDetailScope.prototype, "error", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientDetailScope.prototype, "backLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientDetailScope.prototype, "name", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientDetailScope.prototype, "email", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientDetailScope.prototype, "cpf", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], PatientDetailScope.prototype, "company", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientDetailScope.prototype, "active", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], PatientDetailScope.prototype, "photo", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], PatientDetailScope.prototype, "identification", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], PatientDetailScope.prototype, "anamneseSections", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], PatientDetailScope.prototype, "targets", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], PatientDetailScope.prototype, "historyColumns", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], PatientDetailScope.prototype, "historyRows", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientDetailScope.prototype, "historyPage", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientDetailScope.prototype, "historyPageCount", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientDetailScope.prototype, "openDay", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientDetailScope.prototype, "loadingDay", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientDetailScope.prototype, "openDayLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], PatientDetailScope.prototype, "bucket", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientDetailScope.prototype, "downloadingDay", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientDetailScope.prototype, "dayReportProgress", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], PatientDetailScope.prototype, "analytics", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], PatientDetailScope.prototype, "bands", void 0);
PatientDetailScope = __decorate([
    Observable
], PatientDetailScope);
export { PatientDetailScope };
//# sourceMappingURL=patient-detail.scope.js.map